import React from 'react';

const ModaleSalvaQuestionario = (props) => {
    return ((<div id="messaggioVisibileModal" className="modal fade in" style={{display: "block"}}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            
                            <h4 className="modal-title">Attenzione!</h4>
                            
                        </div>
                        <div className="modal-body row">
                        <h4 className="modal-title">ASSO è stato salvato e reso effettivo.</h4>
                        <h4 className="modal-title">Ora non è più possibile modificarlo.</h4>
                        <h4 className="modal-title">Premi PROCEDI per effettuare il DOWNLOAD del Report PDF.</h4>
                        </div>
                        <div className="modal-footer row">
                           <button onClick={props.procediModaleClicked} type="button" className="btn btn-default" data-dismiss="modal">PROCEDI</button>
                        </div>
                    </div>
                </div>
            </div>));
}

export default ModaleSalvaQuestionario;